// extracted by mini-css-extract-plugin
export default {"custom-icon-link":"mAZF70It--CustomIconLink_custom-icon-link__pButa","customIconLink":"mAZF70It--CustomIconLink_custom-icon-link__pButa"};